import * as types from '../actions/types';

const initialState = {
  loading: false,
  error: null,
  businessId: null, // Business the loaded sections belong to
  sections: null,
};

const menuOptionsReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.MENU_OPTIONS_LOADING:
      return {
        ...state,
        loading: action.payload,
      };

    case types.MENU_OPTIONS_ERROR:
      return {
        ...state,
        error: action.payload.error,
        businessId: action.payload.businessId,
        sections: [],
      };

    case types.MENU_OPTIONS_SET:
      return {
        ...state,
        error: null,
        businessId: action.payload.businessId,
        sections: action.payload.sections,
      };

    default:
      return state;
  }
};

export default menuOptionsReducer;
